import Table from "react-bootstrap/Table";
import Accordion from "react-bootstrap/Accordion";
import BabiesList from "./BabiesList";
import CohabitantsList from "./CohabitantsList";
import Button from "react-bootstrap/Button";
import { Client } from "../requests";
import { useState, useEffect } from "react";
import NewBabyForm from "./NewBabyForm";
import NewCohabitantForm from "./NewCohabitantForm";
import { Link } from "react-router-dom";
import { Alert, Form } from "react-bootstrap";
import { pickUp } from "../requests";

const ClientDetails = (props) => {
  const [lastVisit, setLastVisit] = useState();

  const babies = props.babies;
  const cohabitants = props.cohabitants;

  const iDate = props.interview_date ? new Date(props.interview_date) : null;
  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

  const cDetails = {
    address: props.address,
    cable: props.cable,
    cancelled_date: props.cancelled_date,
    car_insurance: props.car_insurance,
    car_payment: props.car_payment,
    child_tax_credit: props.child_tax_credit,
    city: props.city,
    comments: props.comments,
    date_of_birth: props.date_of_birth,
    dietary_restrictions: props.dietary_restrictions,
    ei_benefits: props.ei_benefits,
    email: props.email,
    employment: props.employment,
    end_date: props.end_date,
    first_name: props.first_name,
    gas: props.gas,
    hydro: props.hydro,
    id: props.id,
    internet: props.internet,
    interview_date: props.interview_date,
    languages: props.languages,
    last_name: props.last_name,
    last_visit: props.last_visit,
    laundry: props.laundry,
    medical: props.medical,
    mortgage: props.mortgage,
    new_client: props.new_client,
    other_expenses: props.other_expenses,
    other_income: props.other_income,
    pension: props.pension,
    phone: props.phone,
    phone_number: props.phone_number,
    postal_code: props.postal_code,
    property_insurance: props.property_insurance,
    property_taxes: props.property_taxes,
    rent: props.rent,
    room_and_board: props.room_and_board,
    social_services: props.social_services,
    start_date: props.start_date,
    strata: props.strata,
    support_maintenance: props.support_maintenance,
    wcb_benefits: props.wcb_benefits,
    admin_comment: props.admin_comment,
    release_signed: props.release_signed,
  };

  const getAge = (date) => {
    let dob = new Date(date);

    let month_diff = Date.now() - dob.getTime();

    let age_dt = new Date(month_diff);

    let year = age_dt.getUTCFullYear();

    let age = Math.abs(year - 1970);

    return age;
  };

  const adults = cohabitants?.filter(
    (cohabitant) => getAge(cohabitant.date_of_birth) >= 18
  );
  const children = cohabitants?.filter(
    (cohabitant) => getAge(cohabitant.date_of_birth) < 18
  );
  const family_size = adults?.length + children?.length + 1;

  const confirmVisit = (id, params) => {
    if (family_size <= 3) {
      pickUp.create({ size: "small" }).then(() => {
        props.getTodaysPickUps();
      });
    } else {
      pickUp.create({ size: "large" }).then(() => {
        props.getTodaysPickUps();
      });
    }
    Client.update(id, params).then((c) => {
      setLastVisit(c.last_visit);
    });
  };

  const [holidayMeal, setHolidayMeal] = useState("");

  const [selectedHolidayMealBtn, setSelectedHolidayMealBtn] = useState();

  const isHolidayMealSelected = (value) => selectedHolidayMealBtn === value;

  const handleHolidayMealClick = (event) =>
    setSelectedHolidayMealBtn(event.currentTarget.value);

  const [holidayVisit, setHolidayVisit] = useState(props?.holiday_visit);

  const confirmHolidayVisit = (id, meal) => {
    Client.update(id, { holiday_meal: meal }).then(() => {
      setHolidayMeal(meal);
    });
    Client.update(id, {
      holiday_visit: new Date().toLocaleDateString("en-CA"),
    }).then((c) => {
      setHolidayVisit(c.holiday_visit);
    });
  };

  const getWeekOfYear = (date) => {
    const inputDate = new Date(date);
    const firstOfJan = new Date(inputDate.getFullYear(), 0, 1);
    const week = Math.ceil(
      ((inputDate.getTime() - firstOfJan.getTime()) / 86400000 +
        firstOfJan.getDay() +
        1) /
        7
    );
    return week;
  };

  return (
    <>
      {iDate <= oneYearAgo ? (
        <Alert variant={"warning"}>
          <b>Interview needed!</b>
        </Alert>
      ) : (
        ""
      )}

      <Table className="align-middle">
        <tbody>
          <tr className="border-dark">
            <td>
              <u>First name:</u>
            </td>

            <td>{props.first_name}</td>
          </tr>
          <tr className="border-dark">
            <td>
              <u>Last name:</u>
            </td>

            <td>{props.last_name}</td>
          </tr>
          <tr className="border-dark">
            <td>
              <u>Last visit:</u>
            </td>

            <td>
              {lastVisit ? lastVisit : props.last_visit}
              <Button
                type="button"
                onClick={() =>
                  confirmVisit(props.id, {
                    last_visit: new Date().toLocaleDateString("en-CA"),
                  })
                }
                className="btn btn-success ms-2"
              >
                Confirm Visit
              </Button>
              {getWeekOfYear(new Date(props.last_visit)) ===
              getWeekOfYear(new Date()) ? (
                <Alert variant="danger" className="w-50 d-inline-block ms-2">
                  <b>Client has already been here this week!</b>
                </Alert>
              ) : (
                ""
              )}
            </td>
          </tr>
          <tr className="border-dark">
            <td>
              <u>Family size:</u>
            </td>
            <td>
              {family_size} total ({adults?.length + 1}{" "}
              {adults.length === 0 ? "adult" : "adults"} {children?.length}{" "}
              {children.length === 1 ? "child" : "children"})
            </td>
          </tr>
          <tr className="border-dark">
            <td>
              <u>Dietary restrictions:</u>
            </td>

            <td>{props.dietary_restrictions}</td>
          </tr>
          <tr className="border-dark">
            <td>
              <u>Age:</u>
            </td>

            <td>{getAge(props.date_of_birth)}</td>
          </tr>
          <tr className="border-dark">
            <td>
              <u>Languages:</u>
            </td>

            <td>{props.languages}</td>
          </tr>
          <tr className="border-dark">
            <td>
              <u>Comments:</u>
            </td>
            <td>{props.comments}</td>
          </tr>
          {props.currentUser?.admin ? (
            <tr className="border-dark">
              <td>
                <u>Admin Comment:</u>
              </td>
              <td>{props.admin_comment}</td>
            </tr>
          ) : (
            ""
          )}

          <tr className="border-dark">
            <td>
              <u>Last holiday meal:</u>
              <div>{holidayMeal ? holidayMeal : props.holiday_meal}</div>

              <Form.Group className="d-flex">
                <Form.Check
                  className="border"
                  htmlFor="holiday_meal"
                  id="holiday_meal"
                  name="holiday_meal"
                  type="radio"
                  label="Chicken"
                  value="Chicken"
                  checked={isHolidayMealSelected("Chicken")}
                  onChange={handleHolidayMealClick}
                />

                <Form.Check
                  className="border mx-3"
                  htmlFor="holiday_meal"
                  id="holiday_meal"
                  name="holiday_meal"
                  type="radio"
                  label="Ham"
                  value="Ham"
                  checked={isHolidayMealSelected("Ham")}
                  onChange={handleHolidayMealClick}
                />

                <Form.Check
                  className="border"
                  htmlFor="holiday_meal"
                  id="holiday_meal"
                  name="holiday_meal"
                  type="radio"
                  label="Turkey"
                  value="Turkey"
                  checked={isHolidayMealSelected("Turkey")}
                  onChange={handleHolidayMealClick}
                />
              </Form.Group>
            </td>

            <td>
              <u className="ml-3">Holiday visit:</u>
              <div className="pr-4">
                {holidayVisit ? holidayVisit : props.holiday_visit}
              </div>
              <Button
                type="button"
                onClick={() =>
                  confirmHolidayVisit(props.id, selectedHolidayMealBtn)
                }
                className="btn btn-success"
              >
                Confirm Holiday Visit
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>

      {props.currentUser?.admin ? (
        <Link
          to={`/clients/${props.id}/edit`}
          state={{ fromClientDetails: cDetails }}
          className="btn btn-success w-100"
        >
          Edit Client
        </Link>
      ) : (
        ""
      )}

      <br />
      {props.currentUser?.admin ? <br /> : ""}

      {babies?.length > 0 ? (
        <BabiesList
          deleteBaby={props.deleteBaby}
          babies={babies}
          currentUser={props.currentUser}
        />
      ) : (
        ""
      )}
      {props.currentUser?.admin ? (
        <Accordion className="d-flex justify-content-center">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <b>Add new baby</b>
            </Accordion.Header>
            <Accordion.Body>
              <NewBabyForm createBaby={props.createBaby} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      ) : (
        ""
      )}
      <br />
      {cohabitants?.length > 0 ? (
        <CohabitantsList
          deleteCohabitant={props.deleteCohabitant}
          cohabitants={cohabitants}
          currentUser={props.currentUser}
        />
      ) : (
        ""
      )}
      {props.currentUser?.admin ? (
        <Accordion className="d-flex justify-content-center">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <b>Add new cohabitant</b>
            </Accordion.Header>
            <Accordion.Body>
              <NewCohabitantForm createCohabitant={props.createCohabitant} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      ) : (
        ""
      )}

      <br />

      {props.currentUser?.admin ? (
        <>
          <div className="d-flex justify-content-around">
            <h3 className="text-center ms-4">Personal Details</h3>
            <h3 className="text-center me-5">Income</h3>
            <h3 className="text-center me-5 pe-3">Expenses</h3>
          </div>
          <div className="d-flex justify-content-center">
            <Table bordered hover className="border-dark">
              <tbody>
                <tr>
                  <td className="text-center align-middle">
                    <u>New client</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.new_client === false ? "No" : "Yes"}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Release Signed</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.release_signed === false ? "No" : "Yes"}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Date of birth</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.date_of_birth}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Address</u>
                  </td>

                  <td className="text-center align-middle">{props.address}</td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>City</u>
                  </td>

                  <td className="text-center align-middle">{props.city}</td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Postal code</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.postal_code}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Phone number</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.phone_number}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Email</u>
                  </td>

                  <td className="text-center align-middle">{props.email}</td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Interview date</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.interview_date}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Start date</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.start_date}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Cancelled date</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.cancelled_date}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>End date</u>
                  </td>

                  <td className="text-center align-middle">{props.end_date}</td>
                </tr>
              </tbody>
            </Table>

            <Table bordered hover className="border-dark">
              <tbody>
                <tr>
                  <td className="text-center align-middle">
                    <u>Employment</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.employment}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Social services</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.social_services}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Child tax credit</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.child_tax_credit}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Support maintenance</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.support_maintenance}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>EI benefits</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.ei_benefits}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>WCB benefits</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.wcb_benefits}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Pension</u>
                  </td>

                  <td className="text-center align-middle">{props.pension}</td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Other income</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.other_income}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Total household income</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.totalHouseholdIncome()}
                  </td>
                </tr>
                <tr>
                  <td className="text-center align-middle">
                    <u>Total household net income</u>
                  </td>

                  <td className="text-center align-middle">
                    {props.totalHouseholdNetIncome()}
                  </td>
                </tr>
              </tbody>
            </Table>

            <Table bordered hover className="border-dark">
              <tbody>
                <tr>
                  <td className="text-center">
                    <u>Room and board</u>
                  </td>

                  <td className="text-center">{props.room_and_board}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Rent</u>
                  </td>

                  <td className="text-center">{props.rent}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Mortgage</u>
                  </td>

                  <td className="text-center">{props.mortgage}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Property insurance</u>
                  </td>

                  <td className="text-center">{props.property_insurance}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Property taxes</u>
                  </td>

                  <td className="text-center">{props.property_taxes}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Strata</u>
                  </td>

                  <td className="text-center">{props.strata}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Laundry</u>
                  </td>

                  <td className="text-center">{props.laundry}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Hydro</u>
                  </td>

                  <td className="text-center">{props.hydro}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Gas</u>
                  </td>

                  <td className="text-center">{props.gas}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Phone</u>
                  </td>

                  <td className="text-center">{props.phone}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Cable</u>
                  </td>

                  <td className="text-center">{props.cable}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Internet</u>
                  </td>

                  <td className="text-center">{props.internet}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Medical</u>
                  </td>

                  <td className="text-center">{props.medical}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Car payment</u>
                  </td>

                  <td className="text-center">{props.car_payment}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Car insurance</u>
                  </td>

                  <td className="text-center">{props.car_insurance}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Other expenses</u>
                  </td>

                  <td className="text-center">{props.other_expenses}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    <u>Total household expenses</u>
                  </td>

                  <td className="text-center">
                    {props.totalHouseholdExpenses()}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </>
      ) : (
        ""
      )}

      <br />
    </>
  );
};

export default ClientDetails;
